export default class LessonRelative {
  readonly id: string
  readonly name: string
  readonly questionCount: number
  readonly answerCount: number

  constructor(data: { [key: string]: any }) {
    this.id = data.id
    this.name = data.name
    this.questionCount = data.questionCount
    this.answerCount = data.answerCount
  }
}
